import apiSlice, { providesList } from "../../app/api/apiSlice";

export const branchesApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getCurrentCompanyBranches: builder.query({
			query: () => `/api/company/branches`,
			transformResponse: (response, _meta, _arg) => {
				return (
					response.data &&
					response.data.map((d, index) => {
						return { lp: index + 1, ...d };
					})
				);
			},
			providesTags: (result) => {
				return providesList(result || null, "Branches");
			},
		}),
		getCompanyWithIdBranches: builder.query({
			query: ({ companyId }) => `/api/company/${companyId}/branches`,
			transformResponse: (response, _meta, _arg) => {
				return (
					response.data &&
					response.data.map((d, index) => {
						return { lp: index + 1, ...d };
					})
				);
			},
			providesTags: (result, error, { companyId }) => {
				return result
					? [
							{ type: "CompanyBranches", id: "LIST" },
							...result.map(() => ({ type: "CompanyBranches", id: companyId })),
					  ]
					: [{ type: "CompanyBranches", id: "LIST" }];
			},
		}),
		addBranch: builder.mutation({
			query: (data) => ({
				url: `/api/branch`,
				method: "POST",
				body: { ...data },
			}),
			invalidatesTags: [{ type: "Branches", id: "LIST" }],
		}),
		editBranchName: builder.mutation({
			query: ({ branchId, data }) => ({
				url: `/api/branch/${branchId}`,
				method: "PUT",
				body: { ...data },
			}),
			invalidatesTags: [{ type: "Branches", id: "LIST" }],
		}),
		removeBranch: builder.mutation({
			query: ({ branchId }) => ({
				url: `/api/branch/${branchId}`,
				method: "DELETE",
			}),
			invalidatesTags: [{ type: "Branches", id: "LIST" }],
		}),
	}),
	overrideExisting: true,
});

export const {
	useGetCurrentCompanyBranchesQuery,
	useGetCompanyWithIdBranchesQuery,
	useAddBranchMutation,
	useEditBranchNameMutation,
	useRemoveBranchMutation,
} = branchesApiSlice;
